import React, {memo} from "react";

const RegisterPrintReport = ({register}) => {
    const initCashBalance = parseInt(register.balance[0]) || 0;
    const cashCollected = register.balance[1] || 0;
    const accountedBalance = register.accountedBalance || 0;
    const finishCashBalance = initCashBalance + cashCollected - accountedBalance;
    return (
        <div className='register-print'>
            <p># {register.id}</p>
            <p>Касир: {register.cashier}</p>
            <p>Початковий залишок: {initCashBalance} грн.</p>
            <p>Готівка: {cashCollected} грн.</p>
            <p>Здано: {accountedBalance} грн.</p>
            {!Number.isNaN(finishCashBalance) && <p>Залишок після здачі: {finishCashBalance} грн.</p>}
            <p>Дата: {new Date().toLocaleDateString('uk')}</p>
        </div>
    )
};

export default memo(RegisterPrintReport);